<template>
  <div class="check-row">
    <div class="check-row__left-title" :style="titleStyle">{{ title }}</div>
    <div class="check-row__right-content">
      <a-row :gutter="0">
        <a-col
          v-for="item in odds"
          :key="item.name"
          :span="24 / colCount"
        >
          <check-grid
            :item="item"
            :selectedOddsItems="selectedOddsItems"
            @selection-change="handleSelectionChange"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { Row, Col } from 'ant-design-vue';
import CheckGrid from './CheckGrid.vue';

// Map each odds group to a tonal chip derived from the design tokens,
// replacing the old literal lightblue / lightgreen / lightpink colours.
const TITLE_TINTS = {
  '胜负':        { bg: '#0B3D2E', fg: '#EAF3EE' },
  '主队胜':      { bg: '#1A7A4C', fg: '#FFFFFF' },
  '平':          { bg: '#2E9460', fg: '#FFFFFF' },
  '主队负':      { bg: '#155D3A', fg: '#FFFFFF' },
  '总进球数':    { bg: '#E0A12E', fg: '#3A2A06' },
  '半全场胜平负': { bg: '#5B6B62', fg: '#FFFFFF' }
};

export default {
  name: 'CheckRow',
  components: {
    CheckGrid,
    'a-row': Row,
    'a-col': Col
  },
  props: {
    colCount: {
      type: Number,
      default: 3
    },
    odds: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    titleColor: {
      type: String,
      default: '#000'
    },
    selectedOddsItems: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    titleStyle() {
      const tint = TITLE_TINTS[this.title] || { bg: '#5B6B62', fg: '#FFFFFF' };
      return { backgroundColor: tint.bg, color: tint.fg };
    }
  },
  methods: {
    handleSelectionChange(event) {
      this.$emit('row-selection-change', event);
    }
  }
}
</script>

<style scoped>
.check-row {
  margin-bottom: 1px;
  display: flex;
  align-items: stretch;
}
.check-row__left-title {
  width: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  writing-mode: vertical-rl;
  text-orientation: upright;
  letter-spacing: 2px;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 0;
  flex: none;
}
.check-row__right-content {
  width: 100%;
  text-align: left;
}
</style>